import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import BookingForm from "./BookingForm";
import AdminPanel from "./AdminPanel";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/book" element={<BookingForm />} />
        <Route path="/admin" element={<AdminPanel />} />
        {/* You can add more routes here */}
      </Routes>
    </Router>
  );

  // return (<p>Site is upgrading. Kindly check back later.</p>);
}

export default App;